import { render, staticRenderFns } from "./BookingSettlementStatus.vue?vue&type=template&id=0bc8ebdc&"
import script from "./BookingSettlementStatus.vue?vue&type=script&lang=js&"
export * from "./BookingSettlementStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports